import React, { useEffect, useState } from "react";
import TauriImage from "../TauriImage/TauriImage";
import "./OpalRadialMenu.css";
import OpalForAcknowledementModal from "./OpalForAcknowledementModal/OpalForAcknowledementModal";
import appURL from '../../appURL.json';
import { useBaseProvider } from "../../BaseManager/BaseManager";
import OpalApprovableMissedCallModal from "./OpalApprovableMissedCallModal/OpalApprovableMissedCallModal";

const OpalRadialMenu = () => {
    const [open, setOpen] = useState(false);
    const [activeComponent, setActiveComponent] = useState(null);
    const [counts, setCounts] = useState({
        acknowledgement: 0,
        approvable_missed_call: 0
    });

    const storedPermission = localStorage.getItem("permission");
    const permission = JSON.parse(atob(storedPermission));

    const { signalRConnection } = useBaseProvider();

    useEffect(() => {
        if (!signalRConnection) return;

        const handleForAcknowledgement  = async (extID) => {
            if (!extID) return;

            await fetchAcknowledgementCount()
        };

        const handleMissedCallRequest  = async (extID) => {
            if (!extID) return;

            await fetchApprovableMissedCallRequestCount()
        };

        signalRConnection.on("ForAcknowledgement", handleForAcknowledgement );
        signalRConnection.on("MissedCallRequest", handleMissedCallRequest );

        return () => {
            signalRConnection.off("ForAcknowledgement", handleForAcknowledgement );
            signalRConnection.off("MissedCallRequest", handleMissedCallRequest );
        };
    }, [signalRConnection]);

    const componentMap = {
        acknowledgement: OpalForAcknowledementModal,
        approvable_missed_call_request: OpalApprovableMissedCallModal
    };

    const items = [
        {
            icon: "/Images/outline-inventory.svg",
            name: "For Acknowledgement",
            action: "acknowledgement",
            show: permission?.coverage?.samples,
            count: counts.acknowledgement
        },
        {
            icon: "/Images/akar-icons--person-cross.svg",
            name: "For Approval Missed Call",
            action: "approvable_missed_call_request",
            show: permission?.coverage?.approve_missed_call,
            count: counts.approvable_missed_call
        }
    ];

    useEffect(() => {
        const handleRefreshAcknowledgement = () => fetchAcknowledgementCount();
        const handleRefreshMissedCallRequest = () => fetchApprovableMissedCallRequestCount();

        window.addEventListener("refreshAcknowledgement", handleRefreshAcknowledgement);
        window.addEventListener("refreshMissedCallRequest", handleRefreshMissedCallRequest);


        return () => {
            window.removeEventListener("refreshAcknowledgement", handleRefreshAcknowledgement);
            window.removeEventListener("refreshMissedCallRequest", handleRefreshMissedCallRequest);
        };
    }, []);

    const fetchAcknowledgementCount = async () => {
        try {
            const isOnline = JSON.parse(localStorage.getItem("isOnline"));
            const hasInternet = navigator.onLine;

            if (isOnline && hasInternet) {
                const token = localStorage.getItem("token");
                const devId = localStorage.getItem("devId");

                const response = await fetch(`${appURL.API_Acknowledgement}/pending`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        "X-ETR-Device-ID": devId
                    },
                });

                if (!response.ok) {
                    setCounts(prev => ({
                        ...prev,
                        acknowledgement: 0
                    }));
                    return;
                }

                const res = await response.json();
                const count = (res?.stocks || []).length;

                setCounts(prev => ({
                    ...prev,
                    acknowledgement: count
                }));
            }
        } catch (error) {
            setCounts(prev => ({
                ...prev,
                acknowledgement: 0
            }));
        }
    };

    const fetchApprovableMissedCallRequestCount = async () => {
        try {
            const isOnline = JSON.parse(localStorage.getItem("isOnline"));
            const hasInternet = navigator.onLine;

            if (isOnline && hasInternet) {
                const token = localStorage.getItem("token");
                const devId = localStorage.getItem("devId");
                const cycleID = localStorage.getItem("c_id");

                const employee_id = Number(permission?.coverage?.employee_id);
                const response = await fetch(`${appURL.API_MissedCallRequest}/approvables/${cycleID}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        "X-ETR-Device-ID": devId
                    },
                });

                if (!response.ok) {
                    setCounts(prev => ({
                        ...prev,
                        approvable_missed_call: 0
                    }));
                    return;
                }

                const res = await response.json();
                const count = (res?.missedCallRequest || []).length;

                setCounts(prev => ({
                    ...prev,
                    approvable_missed_call: count
                }));
            }

        } catch (error) {
            setCounts(prev => ({
                ...prev,
                approvable_missed_call: 0
            }));
        }
    };

    useEffect(() => {
        fetchAcknowledgementCount();
        fetchApprovableMissedCallRequestCount();
    }, []);

    const visibleItems = items.filter(item => item.show);

    const radius = 110;
    const startAngle = -90;
    const endAngle = -180;

    const openIcon = "/Images/material-symbols--close.svg";
    const mainIcon = "/Images/uil--plus.svg";

    const handleClick = (item) => {
        if (item.action) {
            setActiveComponent(item.action);
        }
        setOpen(false);
    };

    const ActiveComponent = componentMap[activeComponent];

    const totalBadgeCount = Object.values(counts).reduce((sum, val) => sum + (val || 0), 0);

    if (visibleItems.length === 0) {
        return null;
    }

    return (
        <div className="opal-radial-menu">
            <button className="main-btn" onClick={() => setOpen(!open)}>
                <span className={`icon ${open ? "open" : ""}`}>
                    <TauriImage
                        localImage={open ? openIcon : mainIcon}
                        alt="main"
                        color="#1D5D9B"
                    />
                </span>
                {totalBadgeCount > 0 && (
                    <span className="badge main-badge">
                        {totalBadgeCount > 99 ? "99+" : totalBadgeCount}
                    </span>
                )}
            </button>

            {visibleItems.map((item, index) => {
                const angle =
                    visibleItems.length === 1
                        ? (startAngle + endAngle) / 2
                        : startAngle +
                        (index / (visibleItems.length - 1)) * (endAngle - startAngle);

                const x = radius * Math.cos((angle * Math.PI) / 180);
                const y = radius * Math.sin((angle * Math.PI) / 180);

                return (
                    <button
                        key={index}
                        className="radial-item"
                        onClick={() => handleClick(item)}
                        style={{
                            transform: open
                                ? `translate(${x}px, ${y}px)`
                                : `translate(0, 0)`,
                            opacity: open ? 1 : 0,
                            pointerEvents: open ? "auto" : "none",
                        }}
                    >
                        <span className="item-icon">
                            <TauriImage
                                localImage={item.icon}
                                alt={item.name}
                                color="#1D5D9B"
                            />
                            {item.count > 0 && (
                                <span className="badge">
                                    {item.count > 99 ? "99+" : item.count}
                                </span>
                            )}
                        </span>
                        <span className="tooltip">{item.name}</span>
                    </button>
                );
            })}

            {ActiveComponent && (
                <ActiveComponent
                    show={true}
                    onHide={() => setActiveComponent(null)}
                />
            )}
        </div>
    );
};

export default OpalRadialMenu;